import { GridApi } from '@ag-grid-community/core'
import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { DeleteBulkTransactionsModalComponent } from '../../components/bulk-transaction/delete-bulk-transaction/delete-bulk-transactions-component'

@Injectable()
export class BulkDeleteService {
  gridApi!: GridApi

  constructor(
    readonly modalService: NgbModal,
    readonly modalPositionService: ModalPositionService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  async deleteHandler() {
    const selectedRows =
      this.gridApi
        .getSelectedNodes()
        .filter(rowNode => rowNode.data.validityStatus != 'inactive') ?? []
    const selectedRowNumber = selectedRows.map(selectedRow =>
      Number((selectedRow.rowIndex ?? 0) + 1),
    )
    if (selectedRowNumber.length == 0) {
      this.openDeleteModal(selectedRowNumber)
    } else {
      try {
        await this.openDeleteModal(selectedRowNumber).result
      } catch (e) {
        /*modal cancelled, nothing to do*/
        return
      }
      this.gridApi.applyTransaction({
        remove: selectedRows.map(row => row.data),
      })
      const deleteSuccessfulEvent = new CustomEvent('deleteSuccessful')
      this.document.dispatchEvent(deleteSuccessfulEvent)
    }
  }
  private openDeleteModal(selectedRowIds: number[]): NgbModalRef {
    const compKey = 'delete-bulk-transactions'
    const uniqueId = compKey + '-' + Date.now()

    const modal = this.modalService.open(DeleteBulkTransactionsModalComponent, {
      keyboard: false,
      windowClass: uniqueId,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })
    const deleteModal: DeleteBulkTransactionsModalComponent =
      modal.componentInstance
    deleteModal.rowsToDelete = selectedRowIds
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modal
  }

  registerGrid(grid: GridApi) {
    this.gridApi = grid
  }
}
